var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCampground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m6.58 3.05-.23.37s-.8 1.21-1.8 2.6c-1 1.38-2.28 2.95-3.03 3.47l-.3.22.03.37.63 5.62.05.55h.57c.93 0 2 .05 3.09.12l.66.04v-5.16H7.5v5.25l.57.06c1.76.16 3.1.32 3.1.32h.1l6.84-1.37.02-.49s.05-1.04.15-2.27c.1-1.22.26-2.66.43-3.18l.14-.43-.33-.25c-2.16-1.67-4.22-5.43-4.22-5.43l-.2-.4-.45.06s-4.01.56-6.66.02zm6.84 1.36c.25.48 1.52 2.74 3.34 4.54l-4.7.74A30 30 0 0 1 8.08 4.5c2.42.25 4.8-.03 5.33-.1m-6.58.51a31 31 0 0 0 4.35 5.65c-.4 1.67-.53 3.9-.56 5l-1.88-.2V10H5v5.1q-1-.06-1.93-.08l-.53-4.8c1-.83 2.09-2.17 3.03-3.46.6-.84.99-1.42 1.27-1.84m10.52 5.22c-.14.74-.26 1.62-.33 2.5-.08.99-.1 1.53-.12 1.85l-5.02 1.02c.04-1.1.15-3.19.47-4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampground);
export default ForwardRef;